/* eslint-disable no-param-reassign */
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '~/store/actions';
import { log, sdpModifierCodec } from '~/helpers/';

export default function useCallHold(value = false) {
  const dispatch = useDispatch();

  const setCallHold = useCallback(
    (session, hold = value) => {
      // const modifier = description => {
      //   description.sdp = description.sdp.replace(
      //     'UDP/TLS/RTP/SAVPF',
      //     'RTP/SAVPF'
      //   );
      //   return Promise.resolve(description);
      // };

      if (session) {
        const sdhOptions = session.sessionDescriptionHandlerOptionsReInvite;
        sdhOptions.hold = hold;
        session.sessionDescriptionHandlerOptionsReInvite = sdhOptions;
        session.sessionDescriptionHandlerModifiersReInvite = [sdpModifierCodec];
        const pc = session.sessionDescriptionHandler?.peerConnection;
        const remoteVideo = new MediaStream();

        if (pc) {
          session
            .invite()
            .then(() => {
              pc.getReceivers().forEach(receiver => {
                if (receiver.track) {
                  receiver.track.enabled = !hold;
                  remoteVideo.addTrack(receiver.track);
                }
              });
              pc.getSenders().forEach(sender => {
                if (sender.track) {
                  sender.track.enabled = !hold;
                }
              });

              // Update the remove video with the last session direction(hold/unhold).
              dispatch(actions.remoteVideo(remoteVideo));
              dispatch(
                actions.updateCall(hold ? 'hold' : 'unhold', session.id)
              );
            })
            .catch(err => {
              log.error('Failed to hold/unhold session. Reason: ', err);
            });
        }
      }
    },
    [dispatch, value]
  );

  return setCallHold;
}
